var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle, _path17, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavGen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 198,
    viewBox: "0 0 245 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 245,
    height: 148,
    rx: 20,
    fill: "url(#paint0_linear_85_4951)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_85_4951",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 245,
    height: 145
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 245,
    height: 145,
    rx: 20,
    fill: "url(#paint1_linear_85_4951)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_85_4951)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.889,
    cy: 13.2971,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4447,
    cy: 13.2971,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.9994,
    cy: 13.2971,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.889,
    cy: 30.8093,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4447,
    cy: 30.8093,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.9994,
    cy: 30.8093,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.889,
    cy: 48.3215,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4447,
    cy: 48.3215,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.9994,
    cy: 48.3215,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.889,
    cy: 65.8332,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.4447,
    cy: 65.8332,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.9994,
    cy: 65.8332,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.333,
    cy: 122.993,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.889,
    cy: 122.993,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 196.333,
    cy: 140.505,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 226.889,
    cy: 140.505,
    rx: 8.33333,
    ry: 5.25362,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.126 197.819C146.258 197.819 168.252 187.633 168.252 175.069C168.252 162.505 146.258 152.32 119.126 152.32C91.9946 152.32 70 162.505 70 175.069C70 187.633 91.9946 197.819 119.126 197.819Z",
    fill: "url(#paint2_radial_85_4951)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.952 163.333V132.637L99.5458 116.803L121.952 163.333ZM97.6875 112.078L121.952 129.221V61.6958L97.6875 112.078Z",
    fill: "url(#paint3_linear_85_4951)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M121.952 163.333L144.363 116.803L121.952 132.637V163.333ZM121.952 61.6958V129.221L146.222 112.078L121.952 61.6958Z",
    fill: "url(#paint4_linear_85_4951)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.951 174.981C124.148 174.981 125.929 141.182 125.929 99.4898C125.929 57.7974 124.148 23.999 121.951 23.999C119.754 23.999 117.973 57.7974 117.973 99.4898C117.973 141.182 119.754 174.981 121.951 174.981Z",
    fill: "url(#paint5_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.951 127.062C129.179 127.062 135.039 114.718 135.039 99.49C135.039 84.2624 129.179 71.918 121.951 71.918C114.723 71.918 108.863 84.2624 108.863 99.49C108.863 114.718 114.723 127.062 121.951 127.062Z",
    fill: "url(#paint6_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.063 180.513C124.275 180.513 126.068 166.661 126.068 149.574C126.068 132.487 124.275 118.635 122.063 118.635C119.852 118.635 118.059 132.487 118.059 149.574C118.059 166.661 119.852 180.513 122.063 180.513Z",
    fill: "url(#paint7_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.951 175.903C129.179 175.903 135.039 163.558 135.039 148.331C135.039 133.103 129.179 120.759 121.951 120.759C114.723 120.759 108.863 133.103 108.863 148.331C108.863 163.558 114.723 175.903 121.951 175.903Z",
    fill: "url(#paint8_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4072 128.321C91.5567 129.032 100.92 111.831 111.325 89.8956C121.731 67.9638 129.237 49.6045 128.087 48.8929C126.938 48.1813 117.574 65.3826 107.169 87.318C96.764 109.253 89.2578 127.609 90.4072 128.321Z",
    fill: "url(#paint9_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7061 116.569C104.06 120.482 114.388 112.808 120.779 99.4191C127.171 86.0305 127.203 72.011 120.849 68.0921C114.494 64.1792 104.167 71.8533 97.7755 85.2419C91.3838 98.6244 91.3517 112.65 97.7061 116.569Z",
    fill: "url(#paint10_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.736 183.524C132.056 182.736 123.746 161.735 112.176 136.621C100.601 111.506 90.1476 91.7846 88.8273 92.5726C87.507 93.3607 95.817 114.361 107.391 139.476C118.966 164.59 129.416 184.312 130.736 183.524Z",
    fill: "url(#paint11_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.086 162.423C127.488 158.613 127.632 144.588 121.406 131.102C115.18 117.616 104.949 109.773 98.5518 113.582C92.1494 117.392 92.0052 131.418 98.2314 144.903C104.452 158.389 114.683 166.233 121.086 162.423Z",
    fill: "url(#paint12_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.92 181.704C112.65 180.948 120.643 160.787 131.777 136.678C142.911 112.568 152.963 93.635 154.237 94.3915C155.507 95.1481 147.513 115.309 136.379 139.418C125.246 163.528 115.193 182.461 113.92 181.704Z",
    fill: "url(#paint13_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.816 162.423C116.413 158.613 116.269 144.588 122.495 131.102C128.721 117.616 138.952 109.773 145.349 113.582C151.752 117.392 151.896 131.418 145.67 144.903C139.454 158.389 129.218 166.233 122.816 162.423Z",
    fill: "url(#paint14_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.244 130.746C153.014 131.501 142.991 113.248 131.853 89.9723C120.714 66.6962 112.683 47.2225 113.91 46.4674C115.14 45.7124 125.164 63.9649 136.302 87.2409C147.44 110.513 155.475 129.991 154.244 130.746Z",
    fill: "url(#paint15_radial_85_4951)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.992 123.731C145.638 127.644 135.311 119.97 128.919 106.581C122.527 93.1926 122.495 79.1731 128.85 75.2542C135.204 71.3413 145.531 79.0154 151.923 92.404C158.315 105.787 158.347 119.812 151.992 123.731Z",
    fill: "url(#paint16_radial_85_4951)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31.038 59.274C27.402 59.274 24.63 61.938 24.63 65.7C24.63 69.462 27.402 72.108 31.056 72.108C34.404 72.108 36.69 69.768 37.194 67.212V65.016H30.39V66.942H34.71C34.332 68.724 33.09 69.84 31.146 69.84C28.806 69.84 27.222 68.256 27.222 65.7C27.222 63.198 28.788 61.596 31.038 61.596C32.37 61.596 33.414 62.154 33.99 63.216H36.888C36.078 60.696 33.846 59.274 31.038 59.274ZM43.3424 63.936C44.6384 63.936 45.6824 64.764 45.7184 66.078H40.9844C41.1824 64.71 42.1364 63.936 43.3424 63.936ZM48.0764 68.868H45.3584C45.0344 69.534 44.4404 70.074 43.3604 70.074C42.1004 70.074 41.0924 69.246 40.9664 67.77H48.2564C48.3104 67.446 48.3284 67.122 48.3284 66.798C48.3284 63.828 46.2944 61.866 43.4144 61.866C40.4624 61.866 38.4104 63.864 38.4104 67.014C38.4104 70.146 40.5164 72.162 43.4144 72.162C45.8804 72.162 47.5364 70.704 48.0764 68.868ZM57.1518 72H59.6718V66.15C59.6718 63.396 58.0158 61.884 55.6938 61.884C54.4158 61.884 53.3358 62.424 52.6878 63.27V62.028H50.1678V72H52.6878V66.492C52.6878 64.89 53.5698 64.026 54.9378 64.026C56.2698 64.026 57.1518 64.89 57.1518 66.492V72ZM66.3522 63.936C67.6482 63.936 68.6922 64.764 68.7282 66.078H63.9942C64.1922 64.71 65.1462 63.936 66.3522 63.936ZM71.0862 68.868H68.3682C68.0442 69.534 67.4502 70.074 66.3702 70.074C65.1102 70.074 64.1022 69.246 63.9762 67.77H71.2662C71.3202 67.446 71.3382 67.122 71.3382 66.798C71.3382 63.828 69.3042 61.866 66.4242 61.866C63.4722 61.866 61.4202 63.864 61.4202 67.014C61.4202 70.146 63.5262 72.162 66.4242 72.162C68.8902 72.162 70.5462 70.704 71.0862 68.868ZM75.6975 67.032C75.6975 65.106 76.5975 64.53 78.0915 64.53H78.7575V61.884C77.3715 61.884 76.3275 62.55 75.6975 63.576V62.028H73.1775V72H75.6975V67.032ZM79.8069 66.978C79.8069 70.092 81.8229 72.162 84.3429 72.162C85.9269 72.162 87.0609 71.406 87.6549 70.542V72H90.1929V62.028H87.6549V63.45C87.0609 62.622 85.9629 61.866 84.3609 61.866C81.8229 61.866 79.8069 63.864 79.8069 66.978ZM87.6549 67.014C87.6549 68.904 86.3949 69.948 85.0089 69.948C83.6589 69.948 82.3809 68.868 82.3809 66.978C82.3809 65.088 83.6589 64.08 85.0089 64.08C86.3949 64.08 87.6549 65.124 87.6549 67.014ZM93.0501 68.904C93.0501 71.19 94.3281 72 96.2361 72H97.8201V69.876H96.6501C95.8581 69.876 95.5881 69.588 95.5881 68.922V64.098H97.8201V62.028H95.5881V59.562H93.0501V62.028H91.8621V64.098H93.0501V68.904ZM103.917 63.936C105.213 63.936 106.257 64.764 106.293 66.078H101.559C101.757 64.71 102.711 63.936 103.917 63.936ZM108.651 68.868H105.933C105.609 69.534 105.015 70.074 103.935 70.074C102.675 70.074 101.667 69.246 101.541 67.77H108.831C108.885 67.446 108.903 67.122 108.903 66.798C108.903 63.828 106.869 61.866 103.989 61.866C101.037 61.866 98.9846 63.864 98.9846 67.014C98.9846 70.146 101.091 72.162 103.989 72.162C106.455 72.162 108.111 70.704 108.651 68.868ZM115.031 72H117.551V63.828L120.935 72H122.843L126.209 63.828V72H128.729V59.436H125.885L121.889 68.778L117.893 59.436H115.031V72ZM140.851 67.014C140.851 63.864 138.601 61.866 135.721 61.866C132.841 61.866 130.591 63.864 130.591 67.014C130.591 70.146 132.769 72.162 135.649 72.162C138.547 72.162 140.851 70.146 140.851 67.014ZM133.147 67.014C133.147 65.016 134.353 64.062 135.685 64.062C137.017 64.062 138.259 65.016 138.259 67.014C138.259 68.994 136.981 69.966 135.649 69.966C134.299 69.966 133.147 68.994 133.147 67.014ZM149.683 72H152.203V66.15C152.203 63.396 150.547 61.884 148.225 61.884C146.947 61.884 145.867 62.424 145.219 63.27V62.028H142.699V72H145.219V66.492C145.219 64.89 146.101 64.026 147.469 64.026C148.801 64.026 149.683 64.89 149.683 66.492V72ZM154.995 68.904C154.995 71.19 156.273 72 158.181 72H159.765V69.876H158.595C157.803 69.876 157.533 69.588 157.533 68.922V64.098H159.765V62.028H157.533V59.562H154.995V62.028H153.807V64.098H154.995V68.904ZM161.578 72H164.098V66.492C164.098 64.89 164.98 64.026 166.348 64.026C167.68 64.026 168.562 64.89 168.562 66.492V72H171.082V66.15C171.082 63.396 169.444 61.884 167.194 61.884C165.862 61.884 164.746 62.424 164.098 63.27V58.68H161.578V72ZM173.478 72H175.998V58.68H173.478V72ZM182.736 68.994L180.162 62.028H177.336L181.332 71.748L179.172 76.716H181.854L188.028 62.028H185.346L182.736 68.994ZM24.63 92.7C24.63 96.462 27.384 99.108 31.002 99.108C33.792 99.108 36.06 97.632 36.906 95.04H34.008C33.414 96.264 32.334 96.858 30.984 96.858C28.788 96.858 27.222 95.238 27.222 92.7C27.222 90.144 28.788 88.542 30.984 88.542C32.334 88.542 33.414 89.136 34.008 90.342H36.906C36.06 87.768 33.792 86.274 31.002 86.274C27.384 86.274 24.63 88.938 24.63 92.7ZM41.5784 94.032C41.5784 92.106 42.4784 91.53 43.9724 91.53H44.6384V88.884C43.2524 88.884 42.2084 89.55 41.5784 90.576V89.028H39.0584V99H41.5784V94.032ZM50.6198 90.936C51.9158 90.936 52.9598 91.764 52.9958 93.078H48.2618C48.4598 91.71 49.4138 90.936 50.6198 90.936ZM55.3538 95.868H52.6358C52.3118 96.534 51.7178 97.074 50.6378 97.074C49.3778 97.074 48.3698 96.246 48.2438 94.77H55.5338C55.5878 94.446 55.6058 94.122 55.6058 93.798C55.6058 90.828 53.5718 88.866 50.6918 88.866C47.7397 88.866 45.6877 90.864 45.6877 94.014C45.6877 97.146 47.7938 99.162 50.6918 99.162C53.1578 99.162 54.8138 97.704 55.3538 95.868ZM56.7971 93.978C56.7971 97.092 58.8131 99.162 61.3511 99.162C62.9171 99.162 64.0331 98.442 64.6271 97.524V99H67.1831V85.68H64.6271V90.414C63.9431 89.478 62.6831 88.866 61.3691 88.866C58.8131 88.866 56.7971 90.864 56.7971 93.978ZM64.6451 94.014C64.6451 95.904 63.3851 96.948 61.9991 96.948C60.6491 96.948 59.3711 95.868 59.3711 93.978C59.3711 92.088 60.6491 91.08 61.9991 91.08C63.3851 91.08 64.6451 92.124 64.6451 94.014ZM69.6443 99H72.1643V89.028H69.6443V99ZM70.9223 87.84C71.8043 87.84 72.4703 87.192 72.4703 86.364C72.4703 85.536 71.8043 84.888 70.9223 84.888C70.0223 84.888 69.3743 85.536 69.3743 86.364C69.3743 87.192 70.0223 87.84 70.9223 87.84ZM75.0501 95.904C75.0501 98.19 76.3281 99 78.2361 99H79.8201V96.876H78.6501C77.8581 96.876 77.5881 96.588 77.5881 95.922V91.098H79.8201V89.028H77.5881V86.562H75.0501V89.028H73.8621V91.098H75.0501V95.904ZM92.5817 90.342C92.5817 91.476 91.9517 92.214 90.5477 92.214H88.4417V88.524H90.5477C91.9517 88.524 92.5817 89.226 92.5817 90.342ZM85.9217 86.436V99H88.4417V94.104H89.6297L92.4017 99H95.3177L92.3117 93.906C94.3277 93.366 95.1737 91.818 95.1737 90.288C95.1737 88.182 93.6617 86.436 90.6377 86.436H85.9217ZM101.737 90.936C103.033 90.936 104.077 91.764 104.113 93.078H99.3789C99.5769 91.71 100.531 90.936 101.737 90.936ZM106.471 95.868H103.753C103.429 96.534 102.835 97.074 101.755 97.074C100.495 97.074 99.4869 96.246 99.3609 94.77H106.651C106.705 94.446 106.723 94.122 106.723 93.798C106.723 90.828 104.689 88.866 101.809 88.866C98.8569 88.866 96.8049 90.864 96.8049 94.014C96.8049 97.146 98.9109 99.162 101.809 99.162C104.275 99.162 105.931 97.704 106.471 95.868ZM111.082 90.468V89.028H108.562V103.752H111.082V97.578C111.694 98.388 112.81 99.162 114.376 99.162C116.932 99.162 118.93 97.092 118.93 93.978C118.93 90.864 116.932 88.866 114.376 88.866C112.828 88.866 111.676 89.622 111.082 90.468ZM116.356 93.978C116.356 95.868 115.078 96.948 113.71 96.948C112.36 96.948 111.082 95.904 111.082 94.014C111.082 92.124 112.36 91.08 113.71 91.08C115.078 91.08 116.356 92.088 116.356 93.978ZM130.392 94.014C130.392 90.864 128.142 88.866 125.262 88.866C122.382 88.866 120.132 90.864 120.132 94.014C120.132 97.146 122.31 99.162 125.19 99.162C128.088 99.162 130.392 97.146 130.392 94.014ZM122.688 94.014C122.688 92.016 123.894 91.062 125.226 91.062C126.558 91.062 127.8 92.016 127.8 94.014C127.8 95.994 126.522 96.966 125.19 96.966C123.84 96.966 122.688 95.994 122.688 94.014ZM134.76 94.032C134.76 92.106 135.66 91.53 137.154 91.53H137.82V88.884C136.434 88.884 135.39 89.55 134.76 90.576V89.028H132.24V99H134.76V94.032ZM139.913 95.904C139.913 98.19 141.191 99 143.099 99H144.683V96.876H143.513C142.721 96.876 142.451 96.588 142.451 95.922V91.098H144.683V89.028H142.451V86.562H139.913V89.028H138.725V91.098H139.913V95.904Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 148,
    r: 22,
    fill: "#FB896B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7071 148.707C55.0976 148.317 55.0976 147.683 54.7071 147.293L48.3431 140.929C47.9526 140.538 47.3195 140.538 46.9289 140.929C46.5384 141.319 46.5384 141.953 46.9289 142.343L52.5858 148L46.9289 153.657C46.5384 154.047 46.5384 154.681 46.9289 155.071C47.3195 155.462 47.9526 155.462 48.3431 155.071L54.7071 148.707ZM32 149H54V147H32V149Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_85_4951",
    x1: -5.86123,
    y1: -7.40003,
    x2: 195.491,
    y2: 59.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534ABA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_85_4951",
    x1: -5.86123,
    y1: -4.25003,
    x2: 194.647,
    y2: 64.2375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7166D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#534ABA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.131 175.061) rotate(-7.18591) scale(53.2774 21.4417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1783,
    stopColor: "#8474D7",
    stopOpacity: 0.7984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3254,
    stopColor: "#8D7EDA",
    stopOpacity: 0.6321
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#9C90DF",
    stopOpacity: 0.4782
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5909,
    stopColor: "#B2A8E6",
    stopOpacity: 0.3318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7156,
    stopColor: "#CEC7EF",
    stopOpacity: 0.1908
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8352,
    stopColor: "#EFEDFA",
    stopOpacity: 0.0556
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8844,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_85_4951",
    x1: 108.379,
    y1: 76.9157,
    x2: 122.338,
    y2: 151.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402F9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_85_4951",
    x1: 126.059,
    y1: 166.034,
    x2: 137.212,
    y2: 80.8344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059157"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.943 99.4925) rotate(90.0036) scale(75.4809 3.97732)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0163,
    stopColor: "#F7F7F7",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#BEBEBE",
    stopOpacity: 0.8675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    stopColor: "#8B8B8B",
    stopOpacity: 0.7478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3729,
    stopColor: "#606060",
    stopOpacity: 0.6273
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3D3D3D",
    stopOpacity: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6166,
    stopColor: "#222222",
    stopOpacity: 0.3836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#0F0F0F",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#040404",
    stopOpacity: 0.1331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.945 99.4925) rotate(90.0325) scale(27.574 13.0849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    stopColor: "#059157",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6566,
    stopColor: "#3B1D3D",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#100811",
    stopOpacity: 0.1153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(122.055 149.575) rotate(90.0089) scale(30.9348 4.00401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0163,
    stopColor: "#F7F7F7",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#BEBEBE",
    stopOpacity: 0.8675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    stopColor: "#8B8B8B",
    stopOpacity: 0.7478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3729,
    stopColor: "#606060",
    stopOpacity: 0.6273
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3D3D3D",
    stopOpacity: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6166,
    stopColor: "#222222",
    stopOpacity: 0.3836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#0F0F0F",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#040404",
    stopOpacity: 0.1331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.945 148.333) rotate(90.0325) scale(27.5739 13.0849)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    stopColor: "#059157",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6566,
    stopColor: "#3B1D3D",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#100811",
    stopOpacity: 0.1153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.249 88.5558) rotate(115.383) scale(43.9527 2.43031)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0163,
    stopColor: "#F7F7F7",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#BEBEBE",
    stopOpacity: 0.8675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    stopColor: "#8B8B8B",
    stopOpacity: 0.7478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3729,
    stopColor: "#606060",
    stopOpacity: 0.6273
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3D3D3D",
    stopOpacity: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6166,
    stopColor: "#222222",
    stopOpacity: 0.3836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#0F0F0F",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#040404",
    stopOpacity: 0.1331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.275 92.3433) rotate(115.555) scale(26.8558 13.4361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    stopColor: "#059157",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6566,
    stopColor: "#059157",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#059157",
    stopOpacity: 0.1153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#059157",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.803 138.107) rotate(65.263) scale(50.0611 2.77054)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0163,
    stopColor: "#F7F7F7",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#BEBEBE",
    stopOpacity: 0.8675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    stopColor: "#8B8B8B",
    stopOpacity: 0.7478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3729,
    stopColor: "#606060",
    stopOpacity: 0.6273
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3D3D3D",
    stopOpacity: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6166,
    stopColor: "#222222",
    stopOpacity: 0.3836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#0F0F0F",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#040404",
    stopOpacity: 0.1331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.817 137.976) rotate(65.2666) scale(26.8986 13.4142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "#059157",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    stopColor: "#059157",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6566,
    stopColor: "#3B1D3D",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#100811",
    stopOpacity: 0.1153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.111 137.96) rotate(114.781) scale(48.0755 2.66415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0163,
    stopColor: "#F7F7F7",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#BEBEBE",
    stopOpacity: 0.8675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    stopColor: "#8B8B8B",
    stopOpacity: 0.7478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3729,
    stopColor: "#606060",
    stopOpacity: 0.6273
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3D3D3D",
    stopOpacity: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6166,
    stopColor: "#222222",
    stopOpacity: 0.3836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#0F0F0F",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#040404",
    stopOpacity: 0.1331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.082 138.056) rotate(114.733) scale(26.8986 13.4142)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    stopColor: "#803E84",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#059157",
    stopOpacity: 0.609558
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6566,
    stopColor: "#3B1D3D",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#100811",
    stopOpacity: 0.1153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(134.09 88.6964) rotate(64.4226) scale(46.7145 2.59728)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0163,
    stopColor: "#F7F7F7",
    stopOpacity: 0.984
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1328,
    stopColor: "#BEBEBE",
    stopOpacity: 0.8675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2525,
    stopColor: "#8B8B8B",
    stopOpacity: 0.7478
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3729,
    stopColor: "#606060",
    stopOpacity: 0.6273
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4942,
    stopColor: "#3D3D3D",
    stopOpacity: 0.5059
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6166,
    stopColor: "#222222",
    stopOpacity: 0.3836
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7405,
    stopColor: "#0F0F0F",
    stopOpacity: 0.2596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#040404",
    stopOpacity: 0.1331
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_85_4951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(140.415 99.4392) rotate(64.4447) scale(26.8558 13.4361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00031472,
    stopColor: "#059157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3372,
    stopColor: "#059157",
    stopOpacity: 0.663
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6566,
    stopColor: "#3B1D3D",
    stopOpacity: 0.3435
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#100811",
    stopOpacity: 0.1153
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGen);
export default __webpack_public_path__ + "static/media/nav-gen.ff8eb695338358a5f65d0626a2f289bc.svg";
export { ForwardRef as ReactComponent };